'use strict';

let helperI18n = require('../components/utils/helper/helper-i18n.jsx').helperI18n,
	mobile,
	mobileInternet,
	fixnet,
	upcMobile,
	newHardware,
	newMobile,
	preToPost,
	newMobileAccessory,
	airbagMobilePostpaid,
	mobileForQoQa;

mobile = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo', 'applySubscriber', 'subscriberInfo'],
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo','deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			alternateGroupName: helperI18n('FormPersonalDataExpress.ActivationAddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.MobileNumberSection.Title'),
			component: 'NumberFormComponent',
			formCommand: 'porting',
			subCommands: ['deliveryInfo']
		}
	]
};
upcMobile = {
	type: 'mobile',
	components: [
		{
			component: 'NumberFormComponent',
			formCommand: 'porting',
			subCommands: ['deliveryInfo']
		},
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo'],
			variant: {
				title: helperI18n('FormPersonalDataExpress.PersonalInformation')
			}
		},

		{
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress', 'deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		}
	]
};
mobileInternet = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo', 'applySubscriber', 'subscriberInfo']
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo','deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.MobileNumberSection.Title'),
			component: 'NumberFormComponent',
			formCommand: 'porting',
			subCommands: ['deliveryInfo']
		}
	]
};
newMobile = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo', 'applySubscriber', 'subscriberInfo']
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo','deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
	]
};
preToPost = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo', 'applySubscriber', 'subscriberInfo']
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo','deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
	]
};
fixnet = {
	type: 'fixnet',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck']
		},
		{
			component: 'FormTvLogin',
			formCommand: 'defaultAddress'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'currentAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress','deliveryAddress','sameActivationAddress', 'defaultAddress', 'storePickupInfo', 'deliveryType'],
			variant: {
				title: helperI18n('FormAddress.CurrentAddress'),
				showAddressOptions: true,
				readOnly: false,
			}
		},
		{
			component: 'FormConnectionStep',
			formCommand: 'electricianPackage'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.LandlineNumberSection.Title'),
			component: 'FixnetNumberCheck',
			formCommand: 'porting'
		}
	]
};
newHardware = {
	type: 'NewMobileDevice',
	components: [
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress']
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress', 'deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		}
	]
};
newMobileAccessory = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo']
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		}
	]
};

airbagMobilePostpaid = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo']
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo', 'deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress', 'deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.MobileNumberSection.Title'),
			component: 'NumberFormComponent',
			formCommand: 'porting',
			subCommands: ['deliveryInfo']
		}
	]
};
mobileForQoQa = {
	type: 'mobile',
	components: [
		{
			component: 'FormScanProcess',
			formCommand: ''
		},
		{
			component: 'FormPersonalDataExpress',
			formCommand: 'defaultAddress',
			subCommands: ['defaultAddress', 'identityCheck', 'deliveryInfo', 'applySubscriber', 'subscriberInfo'],
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.QoqaAccountSection.Title'),
			component: 'QoQaEmailValidation',
			formCommand: 'qoqaEmailId',
			subCommands: ['qoqaEmailId'],
		},
		{
			component: 'FormSubscriberData',
			formCommand: 'subscriberInfo',
			subCommands: ['applySubscriber', 'subscriberInfo','deliveryInfo'],
			variant: {
				title: helperI18n('FormSubscriberData.Title')
			}
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.AddressSection.Title'),
			alternateGroupName: helperI18n('FormPersonalDataExpress.ActivationAddressSection.Title'),
			component: 'FormAddressCheckout',
			formCommand: 'defaultAddress',
			subCommands: ['differentBillingAddress', 'differentDeliveryAddress', 'billingAddress', 'deliveryAddress', 'defaultAddress','deliveryInfo'],
			variant: {
				title: helperI18n('FormAddress.Address'),
				showAddressOptions: true,
				readOnly: false
			}
		},
		{
			component: 'FormRadioDelivery',
			formCommand: 'deliveryInfo'
		},
		{
			groupName: helperI18n('FormPersonalDataExpress.MobileNumberSection.Title'),
			component: 'NumberFormComponent',
			formCommand: 'porting',
			subCommands: ['deliveryInfo']
		}
	]
};

module.exports = {
	CART_ID_COOKIE_NAME: 'sunriseCartId',
	FORM_ADDRESS_CHECKOUT: 'FormAddressCheckout',
	FORM_TV_LOGIN: 'FormTvLogin',
	TV_HZN: 'TV_HZN',
	TV_LOGIN_PREFIX: ['078', '079', '077', '076'],
	FORM_PERSONAL_DATA_EXPRESS: 'FormPersonalDataExpress',
	DELIVERY_ADDRESS: 'deliveryAddress',
	BC_NEWMOBILEDEVICE: 'BC-NewMobileDevice',
	TYPE_HOME: 'home',
	TYPE_MOBILE: 'mobile',
	ERROR: 'Error',
	BACKEND_ERROR: 'backendError',
	SAVED_CARD: 'SavedCard',
	BINDING_PROMOTION: 'BINDING_PROMOTION',
	RATEPLAN_HAS_NO_UPGRADE_OPTION: 'RATEPLAN_HAS_NO_UPGRADE_OPTION',
	FIXNET_OTT_RC:'RC-Fixnet-OTT-SubscriptionPlan',
	FIXNET_OTT_SOHO:'SOHO-Fixnet-OTT-SubscriptionPlan',
	FIXNET_OTT_CONSTANT: ['RC-Fixnet-OTT-SubscriptionPlan', 'SOHO-Fixnet-OTT-SubscriptionPlan', 'RC-FixnetAlternative-OTT-SubscriptionPlan'],
	QOQAEMAILVALIDATION: 'QoQaEmailValidation',
	VOUCHER_APPLIED_CART_PACKAGES: ['RC-MobileInternetPostpaid','SOHO-MobileInternetPostpaid', 'RC-AddExtraSimSurfTalk', 'SOHO-AddExtraSimSurfTalk'],
	bundles: {
		'RC-MobilePostpaid': mobile,
		'SOHO-MobilePostpaid': mobile,
		'RC-BabsiMobilePostpaid': mobile,
		'SOHO-BabsiMobilePostpaid': mobile,
		'RC-SimOnly': mobile,
		'RC-MobilePrepaid' : mobile,
		'RC-YoungMobilePrepaid' : mobile,
		'RC-MobileInternetPostpaid' : mobileInternet,
		'SOHO-MobileInternetPostpaid' : mobileInternet,
		'RC-AddExtraSimSurfTalk' : mobileInternet,
		'SOHO-AddExtraSimSurfTalk' : mobileInternet,
		'RC-Fixnet':fixnet,
		'SOHO-Fixnet':fixnet,
		'RC-OneFixnet':fixnet,
		'SOHO-OneFixnet':fixnet,
		'RC-OneFixnetAlternative':fixnet,
		'SOHO-OneFixnetAlternative':fixnet,
		'BC-NewMobileDevice':newHardware,
		'RC-NewMobileDevice': newMobile,
		'RC-BabsiNewMobileDevice': newMobile,
		'RC-NewTabletDevice': newMobile,
		'SOHO-NewMobileDevice': newMobile,
		'SOHO-BabsiNewMobileDevice': newMobile,
		'SOHO-NewTabletDevice': newMobile,
		'RC-MobilePreToPost' : preToPost,
		'SOHO-MobilePreToPost' : preToPost,
		'RC-BabsiMobilePreToPost' : preToPost,
		'SOHO-BabsiMobilePreToPost' : preToPost,
		'RC-WearablePostpaid' : mobile,
		'SOHO-WearablePostpaid' : mobile,
		'RC-Hardware' : newMobileAccessory,
		'SOHO-Hardware' : newMobileAccessory,
		'RC-IndependentWearablePostpaid' : mobile,
		'SOHO-IndependentWearablePostpaid' : mobile,
		'RC-NewDeviceToIndependentWearablePostpaid' : newMobileAccessory,
		'SOHO-NewDeviceToIndependentWearablePostpaid' : newMobileAccessory,
		'RC-AddExtraWatch' : newMobileAccessory,
		'SOHO-AddExtraWatch' : newMobileAccessory,
		'RC-AddExtraSimWatch' : mobileInternet,
		'SOHO-AddExtraSimWatch' : mobileInternet,
		'RC-NewMobileAccessory': newMobileAccessory,
		'SOHO-NewMobileAccessory': newMobileAccessory,
		'RC-AirbagMobilePostpaid': airbagMobilePostpaid,
		'SOHO-AirbagMobilePostpaid': airbagMobilePostpaid,
		'RC-NewWinAccessory': newMobileAccessory,
		'SOHO-NewWinAccessory': newMobileAccessory,
		'RC-FixnetAlternative':fixnet,
		'SOHO-FixnetAlternative':fixnet,
		'RC-MobilePostpaidUPCMigration': upcMobile,
		'SOHO-MobilePostpaidUPCMigration': upcMobile,
		'RC-FixnetUPCMigration': fixnet,
		'SOHO-FixnetUPCMigration': fixnet,
		'RC-MobilePostpaidPromotion': mobileForQoQa,
		'SOHO-MobilePostpaidPromotion': mobileForQoQa
	},
	EXPRESS_CHECKOUT_BUNDLE_TEMPLATES: ['RC-AddExtraSimSurfTalk', 'SOHO-AddExtraSimSurfTalk'],
	CHECKOUT_EXPRESS: 'CheckoutExpress',
	MOBILEINTERNET_POSTPAID: 'MobileInternetPostpaid',
	MOBILE_POSTPAID_SIMCARD: 'MobilePostpaid-RatePlanSimCard',
	BABSI_MOBILE_POSTPAID_SIMCARD: 'BabsiMobilePostpaid-RatePlanSimCard',
	MOBILEINTERNET_POSTPAID_SIMCARD : 'MobileInternetPostpaid-TakeAwaySimCard',
	EXPRESS_CHECKOUT_FLOW: [
		'RC-Fixnet',
		'SOHO-Fixnet',
		'RC-FixnetOne',
		'RC-Hardware',
		'SOHO-Hardware',
		'RC-OneFixnetAlternative',
		'SOHO-OneFixnetAlternative',
		'SOHO-FixnetOne',
		'RC-MobilePrepaid',
		'RC-YoungMobilePrepaid',
		'RC-MobilePostpaid',
		'SOHO-MobilePostpaid',
		'RC-BabsiMobilePostpaid',
		'SOHO-BabsiMobilePostpaid',
		'RC-NewMobileDevice',
		'RC-BabsiNewMobileDevice',
		'RC-NewTabletDevice',
		'SOHO-NewMobileDevice',
		'SOHO-BabsiNewMobileDevice',
		'BC-NewMobileDevice',
		'SOHO-NewTabletDevice',
		'RC-MobilePostpaidUPCMigration',
		'SOHO-MobilePostpaidUPCMigration',
		'RC-MobilePreToPost',
		'SOHO-MobilePreToPost',
		'RC-BabsiMobilePreToPost',
		'SOHO-BabsiMobilePreToPost',
		'RC-MobileInternetPostpaid',
		'SOHO-MobileInternetPostpaid',
		'RC-AddExtraSimWatch',
		'SOHO-AddExtraSimWatch',
		'RC-AddExtraWatch',
		'SOHO-AddExtraWatch',
		'RC-NewDeviceToIndependentWearablePostpaid',
		'SOHO-NewDeviceToIndependentWearablePostpaid',
		'RC-IndependentWearablePostpaid',
		'SOHO-IndependentWearablePostpaid',
		'RC-WearablePostpaid',
		'SOHO-WearablePostpaid',
		'RC-NewMobileAccessory',
		'SOHO-NewMobileAccessory',
		'RC-AddExtraSimSurfTalk',
		'SOHO-AddExtraSimSurfTalk',
		'RC-AirbagMobilePostpaid',
		'SOHO-AirbagMobilePostpaid',
		'RC-NewWinAccessory',
		'SOHO-NewWinAccessory',
		'RC-FixnetAlternative',
		'SOHO-FixnetAlternative',
		'RC-FixnetUPCMigration',
		'SOHO-FixnetUPCMigration',
		'RC-MobilePostpaidPromotion',
		'SOHO-MobilePostpaidPromotion'
	],

	PAYMENT_MODE_CREDIT_CARD : 'checkout_cc',
	PAYMENT_MODE_POST_FINANCE : 'checkout_post',
	PAYMENT_MODE_INVOICE : 'checkout_invoice',
	CHECKOUT_EXPRESS_FORM_DATA_LOCAL_STORAGE: 'checkout_express_form_data',
	CHECKOUT_EXPRESS_FORM_DATA_PORTING_LOCAL_STORAGE: 'checkout_express_form_data_porting',
	EXPIRATION_TIME: 12*60,
	DEFAULT_ADDRESS_FIELDS: [
		'country',
		'email',
		'firstName',
		'lastName',
		'titleCode',
		'phone',
		'postalCode',
		'town',
		'streetName',
		'streetNumber'
	],
	IDENTITY_CHECK_FIELDS: [
		'birthDate',
		'passportExpiryDate',
		'passportNumber',
		'type'
	],
	DELIVERY_ADDRESS_FIELDS: [
		'postalCode',
		'town',
		'streetName',
		'streetNumber'
	],
	WE_CONNECT_WIFI: 'We Connect WiFi',
	STANDALONE: 'Standalone',
	SLAVE: 'SLAVE',
	EXISTING: 'Existing',
	NEW: 'New',
	EMPLOYEE: 'EMPLOYEE',
	EMPLOYER: 'EMPLOYER',
	paymentType: {
		PFC: 'postfinance',
		PEF: 'efinance',
		AMX: 'american-express',
		VIS: 'visa',
		ECA: 'mastercard'
	},
	PREPAID_FLOW: [
		'RC-MobilePrepaid',
		'RC-YoungMobilePrepaid'
	],
	SCAN_PROCESS_NOT_REQUIRED: 'scan_process_not_required',
	ORDER_DATA: 'order_data',
	EXCLUDE_SAVE_MY_BASKET_PACKAGES: [
		'RC-NewMobileDevice',
		'SOHO-NewMobileDevice',
		'RC-BabsiNewMobileDevice',
		'SOHO-BabsiNewMobileDevice',
		'BC-NewMobileDevice',
		'RC-AddExtraSimWatch',
		'SOHO-AddExtraSimWatch',
		'BC-AddExtraSimWatch',
		'RC-NewTabletDevice',
		'SOHO-NewTabletDevice',
		'BC-NewTabletDevice',
		'RC-AddExtraSimSurfTalk',
		'SOHO-AddExtraSimSurfTalk',
		'BC-AddExtraSimSurfTalk',
		'RC-NewDeviceToIndependentWearablePostpaid',
		'SOHO-NewDeviceToIndependentWearablePostpaid',
		'BC-NewDeviceToIndependentWearablePostpaid'
	],
	TELLJA_PRODUCT_PACKAGES_MOBILE_POSTPAID: [
		'RC-MobilePostpaid',
		'SOHO-MobilePostpaid',
		'RC-BabsiMobilePostpaid',
		'SOHO-BabsiMobilePostpaid',
		'RC-MobilePreToPost',
		'SOHO-MobilePreToPost',
		'RC-BabsiMobilePreToPost',
		'SOHO-BabsiMobilePreToPost',
		'RC-MobilePostpaidUPCMigration',
		'SOHO-MobilePostpaidUPCMigration'
	],
	TELLJA_PRODUCT_PACKAGES_FIXNET: [
		'RC-Fixnet',
		'SOHO-Fixnet',
		'RC-FixnetAlternative',
		'SOHO-FixnetAlternative',
		'RC-FixnetUPCMigration',
		'SOHO-FixnetUPCMigration'
	],
	TELLJA: 'Tellja',
	CHECKOUT_EXPRESS_LOGOUT: 'logoutTriggered',
	CHECKOUT_EXPRRESS_OTHEROWNER: 'private',
	CHECKOUT_EXPRRESS_COMPANY: 'company',
	CHECKOUT_EXPRRESS_ME: 'me',
	CHECKOUT_EXPRRESS_CONTRACTUALOBLIGATION: 'Yes',
	TELLJA_EXPIRATION_TIME: 1000 * 60 * 60 * 24 * 30 ,
	AFFILIATION: 'Affiliation',
	AFFILIATION_EXPIRATION_TIME: 1000 * 60 * 60 * 24 * 30
};



// WEBPACK FOOTER //
// ./src/constants/checkout-express-constants.js